export default "__VITE_ASSET__BwQULAKc__"